import { combineReducers } from 'redux';
import creer from './creer';
import recupererLogin from './recupererLogin';
import changementResponsableLegal from './changementResponsableLegal';

const compte = combineReducers({
    creer,
    recupererLogin,
    changementResponsableLegal,
});

export default compte;
